export enum NAVBoolean {
  unknown = "unknown",
  true = "true",
  false = "false",
}
